import React, { useState } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import cab from "../assets/careerbanner.png";
import ScrollToTopButton from "../components/ScrollToTopButton";

export default function CareersPage() {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    ph_number: "",
    experience_level: "",
    exp_description: "",
    position: "Software Developer", 
  });
  const [resumeFile, setResumeFile] = useState(null);
  const [status, setStatus] = useState("");
  const [errors, setErrors] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setResumeFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");
    setErrors([]);

    if (!resumeFile) {
      setErrors(["Please upload your resume."]);
      return;
    }

    try {
      const payload = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        payload.append(key, value);
      });
      payload.append("resume", resumeFile);

      const response = await axios.post("http://localhost:8000/api/v1/careers", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success) {
        setStatus(response.data.message || "Form submitted successfully!");
        setFormData({
          first_name: "",
          last_name: "",
          email: "",
          ph_number: "",
          experience_level: "",
          exp_description: "",
          position: "Software Developer",
        });
        setResumeFile(null);
      } else {
        setErrors(response.data.errors || [response.data.message || "Submission failed"]);
      }
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      } else {
        setErrors(["An unexpected error occurred."]);
      }
    }
  };

  return (
    <>
      <Navbar />
      <div className="position-relative" style={{ marginTop: "70px" }}>
        {/* Banner Section */}
        <div className="container-fluid py-5" style={{ background: "linear-gradient(to right, #ffffff 50%, #ffffff 50%)" }}>
          <div className="row align-items-center justify-content-between px-3">
            <div className="col-lg-6 col-md-12 mb-4 mb-lg-0 text-center text-lg-start">
              <h1 className="display-5 fw-bold mb-3">
                Define your career with <span style={{ color: "#0F62FE" }}>Vizionexl</span>
              </h1>
              <p className="text-muted mb-4">
                <b>CODE THE FUTURE. BUILD WITH VISION. DELIVER WITH EXCELLENCE</b>
                <br />
                Our curiosity runs deep. That’s why we let you explore new paths
                at your own speed — making sure you’re constantly learning.
                Discover the possibilities.
              </p>
              <h6 className="text-primary fw-semibold">📍 Job Location: Bijapur</h6>
            </div>
            <div className="col-lg-6 col-md-12 text-center">
              <img src={cab} alt="Career" className="img-fluid" style={{ maxHeight: "400px", objectFit: "cover" }} />
            </div>
          </div>
        </div>

        {/* Application Form */}
        <div className="container my-5">
          <h3 className="mb-4 fw-semibold text-center">Apply Now</h3>
          <form className="row g-3" onSubmit={handleSubmit}>
            <div className="col-md-6">
              <label className="form-label">First Name</label>
              <input
                type="text"
                name="first_name"
                className="form-control"
                value={formData.first_name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Last Name</label>
              <input
                type="text"
                name="last_name"
                className="form-control"
                value={formData.last_name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Email Address</label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Phone Number</label>
              <input
                type="tel"
                name="ph_number"
                className="form-control"
                value={formData.ph_number}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Upload Resume</label>
              <input
                type="file"
                className="form-control"
                accept=".pdf,.doc,.docx"
                onChange={handleFileChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Experience Level</label>
              <select
                name="experience_level"
                className="form-select"
                value={formData.experience_level}
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option value="Fresher">Fresher</option>
                <option value="Experienced">Experienced</option>
              </select>
            </div>

            {formData.experience_level === "Experienced" && (
              <div className="col-12">
                <label className="form-label">Relevant Experience</label>
                <textarea
                  name="exp_description"
                  className="form-control"
                  rows="4"
                  placeholder="Describe your experience in detail"
                  value={formData.exp_description}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
            )}

            <div className="col-12 text-center">
              <button type="submit" className="btn btn-primary px-5 mt-3">
                Submit Application
              </button>
              {status && <p className="text-success mt-3">{status}</p>}
              {errors.length > 0 && (
                <div className="text-danger mt-3">
                  <ul>
                    {errors.map((err, idx) => (
                      <li key={idx}>{err}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
      <Footer />
      <ScrollToTopButton />
    </>
  );
}
